import { createReducer, on, createFeature, provideState } from '@ngrx/store';
import { ChatHeaderActions } from './chat-header.actions';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { ChatHeaderEffects } from './chat-header.effects';

export const initialState: Readonly<ChatHeader> = {
  logo: '',
  title: '',
  isLiveChatHeader: false,
};

export const chatHeaderFeature = createFeature({
  name: 'chatHeader',
  reducer: createReducer(
    initialState,
    on(ChatHeaderActions.setHeader, (state, { value }) => {
      return value;
    }),
    on(ChatHeaderActions.setLogo, (state, { value }) => {
      return { ...state, logo: value };
    }),
    on(ChatHeaderActions.setTitle, (state, { value }) => {
      return { ...state, title: value };
    })
  ),
});

export const {
  selectChatHeaderState,
  selectLogo,
  selectTitle,
  selectIsLiveChatHeader,
} = chatHeaderFeature;

export function provideChatHeaderFeature() {
  return makeEnvironmentProviders([
    provideState(chatHeaderFeature),
    provideEffects(ChatHeaderEffects),
  ]);
}
